import ProjectMap from "../components/ProjectMap";

const Home = () => {
    return (
      <div className="app">
        <div className="app_info">
          <div><h3>Hey, I’m Jake👋 </h3><span className='role'>UX Designer</span> </div>
          <h1>Composing designs, pixel by pixel, note by note</h1>
        </div>
        <ProjectMap />
      </div>
    );
  }

  export default Home